import { useDispatch } from 'react-redux';
import { Button, Modal } from '../../../../component';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import {
  clearMap,
  modalOpen,
  setDisplayStudyCreationGuide,
} from '../../redux/dashboardActions';
import nls from '../nls/pt-BR.json';
import { deleteStudy } from '../redux/studies.controller';
import { advanceToStep, studiesSelector } from '../redux/studies.reducer';

export const ConfirmExitModal: React.FC = () => {
  const { statusModal } = useTypedSelector((state) => state.dashboardState);
  const { id } = useTypedSelector(studiesSelector);
  const dispatch = useDispatch();
  const closeModalsResetGuide = () => {
    dispatch([
      modalOpen(''),
      setDisplayStudyCreationGuide(false),
      advanceToStep('initialState'),
      clearMap(),
    ]);
  };
  const handleClickDiscard = () => {
    closeModalsResetGuide();
    dispatch(deleteStudy(id));
  };
  const handleClickSave = () => {
    closeModalsResetGuide();
  };
  return (
    <Modal
      open={statusModal === 'confirm exit study creation guide'}
      title={
        <span style={{ color: '#383939' }}>{nls.modal.confirmExit.title}</span>
      }
      close={() => dispatch(modalOpen(''))}
      cy="ConfirmExitStudyCreationGuide"
      hasCancelBtn={false}
      actions={
        <>
          <Button
            className="btn normal secondary"
            cy="DiscardStudy"
            onClick={handleClickDiscard}
            style={{ border: '1px solid #383939', color: '#383939' }}
          >
            {nls.modal.confirmExit.discard}
          </Button>
          <Button
            cy="SaveStudy"
            className="btn normal primary"
            onClick={handleClickSave}
          >
            {nls.modal.save}
          </Button>
        </>
      }
    >
      <p>{nls.modal.confirmExit.helper}</p>
    </Modal>
  );
};
